import { filter, find, includes, isNull, parseInt, union } from 'lodash/fp';
// @ts-expect-error - Automatic, Please fix when editing this file
import { static as Immutable } from 'seamless-immutable';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { REHYDRATE } from 'redux-persist';

import {
  CLEAR_CART,
  EXTRAS_CHANGE,
  HOSPITAL_CHANGE,
  HOSPITAL_EXCESS_CHANGE,
  PAYMENT_SUBMIT_SUCCESS,
  PRODUCT_CHANGE,
} from '../../actions/action-types';
import getSaleableCombinedProductIds from '../../utils/get-saleable-combined-product-ids';
import getSaleableProductIds from '../../utils/get-saleable-product-ids';
import ProductService from '../../models/product';
import setComplementary from './setComplementary';

const radix = 10;

const emptyProduct = Immutable.from({
  id: null,
  name: null,
  rank: null,
  scales: null,
  type: null,
});
const initialState = Immutable.from({
  baseProductType: null,
  extras: emptyProduct,
  hospital: emptyProduct,
  product: emptyProduct,
});

const cartReducer = (oldState = initialState, action = {}) => {
  const state = Immutable.from(oldState);
  const reducers = {
    [CLEAR_CART]: () => initialState,
    [EXTRAS_CHANGE]: setComplementary({
      // @ts-expect-error - Automatic, Please fix when editing this file
      product: action.product,
      productType: PRODUCT_TYPE.EXTRAS,
      state,
    }),
    [HOSPITAL_CHANGE]: setComplementary({
      // @ts-expect-error - Automatic, Please fix when editing this file
      product: action.product,
      productType: PRODUCT_TYPE.HOSPITAL,
      state,
    }),
    [HOSPITAL_EXCESS_CHANGE]: () => {
      // @ts-expect-error - Automatic, Please fix when editing this file
      const { hospitalExcess, products } = action;

      // get products with excess via parent product
      // hospital or package
      const productParent = find(
        {
          id: state?.hospital?.id || state?.product?.id,
        },
        products,
      );

      const productParentId = productParent?.parentProductId;

      const productsWithExcess = filter(
        {
          parentProductId: productParentId,
        },
        products,
      );

      // find product with charges.excess.amount that matches selected hospitalExcess
      const hospitalExcessProduct = find(
        {
          charges: {
            excess: {
              amount: parseInt(radix, hospitalExcess),
            },
          },
        },
        productsWithExcess,
      );

      const productAsCartObject = ProductService.getCartObject(hospitalExcessProduct);

      // Complementary only, we do this to keep complementary in state when changing excess
      if (state?.extras?.id) {
        return setComplementary({
          product: hospitalExcessProduct,
          productType: PRODUCT_TYPE.HOSPITAL,
          state,
        })();
      }

      // Hospital only or package
      return Immutable.merge(initialState, {
        baseProductType: productAsCartObject.type,
        [productAsCartObject.type]: productAsCartObject,
        product: productAsCartObject,
      });
    },
    [PAYMENT_SUBMIT_SUCCESS]: () => initialState,
    [PRODUCT_CHANGE]: () => {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'product' does not exist on type '{}'.
      const type = action?.product?.type;

      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'product' does not exist on type '{}'.
      if (action?.product?.id === state?.[type]?.id) {
        return Immutable.set(state, 'baseProductType', type);
      }

      // @ts-expect-error - Automatic, Please fix when editing this file
      const cartObject = ProductService.getCartObject(action.product);
      const baseState = Immutable.merge(initialState, {
        baseProductType: type,
        product: cartObject,
      });

      if (isNull(type)) {
        return baseState;
      }

      return Immutable.set(baseState, type, cartObject);
    },
    [REHYDRATE]: () => {
      // @ts-expect-error - Automatic, Please fix when editing this file
      if (action.key === 'cart') {
        // Ensure that cart is empty
        if (!isNull(state?.baseProductType)) {
          return state;
        }

        // Ensure that product being rehydrated is saleable
        const allSaleableProductIds = union(getSaleableProductIds(), getSaleableCombinedProductIds());
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'payload' does not exist on type '{}'.
        if (!includes(action?.payload?.product?.id, allSaleableProductIds)) {
          return state;
        }

        // @ts-expect-error - Automatic, Please fix when editing this file
        return { ...initialState, ...action.payload };
      }

      return state;
    },
  };
  // @ts-expect-error - Automatic, Please fix when editing this file
  return reducers[action.type]
    ? // @ts-expect-error - Automatic, Please fix when editing this file
      Immutable.asMutable(reducers[action.type](), {
        deep: true,
      })
    : oldState;
};

export default cartReducer;
